import { Button, Card, Col, Row, Form, Collapse, Container, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";
import SondaggiService from "../../../services/SondaggiService";
import { RiFilter3Line } from "react-icons/ri"
//import CartaBilancio from "./CartaBilancio";
import { getStatusSondaggio } from "../../Utilities/getStatus";
import { getStatusOrderSondaggio } from "../../Utilities/getStatusOrder";
import { statiSondaggio } from "../../Utilities/statiElementEnum";
import { FaRegCalendarAlt } from "react-icons/fa";
import PaginationBasic from "../Homepage/Pagination"
import { Link, useNavigate, Navigate } from "react-router-dom";
import Multiselect from 'multiselect-react-dropdown';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import CartaBilancio from "../Homepage/CartaBilancio";
import CartaSondaggio from "./CartaSondaggio";
import SondaggioPartecipanteService from "../../../services/SondaggioPartecipanteService";
import { RiEmotionSadLine } from "react-icons/ri"

/*
<EsploraSondaggi comune={comune} setActiveTab={setActiveTab} partecipante={partecipante} />

*/

// Funzione helper per leggere in sicurezza da sessionStorage
const getInitialState = (key, defaultValue) => {
    const storedValue = sessionStorage.getItem(key);
    if (storedValue === null) {
        return defaultValue;
    }
    try {
        const parsed = JSON.parse(storedValue);
        return parsed !== null ? parsed : defaultValue;
    } catch (e) {
        console.warn(`Errore nel parsing del sessionStorage [${key}]:`, e);
        return defaultValue;
    }
};


export default function EsploraSondaggi(props) {

    const dayjs = require('dayjs');

    const [options, setOptions] = useState([])
    const [selectedOptions, setselectedOptions] = useState(() =>
        getInitialState('filtriSondaggi_selectedOptions', [])
    );

    let [categoriaFilter, setCategoriaFilter] = useState(() =>
        getInitialState('filtriSondaggi_categoriaFilter', [])
    );

    // Filtri
    let [statoFilter, setStatoFilter] = useState(() =>
        getInitialState('filtriSondaggi_statoFilter', [])
    );
    const [dateRange, setDateRange] = useState(() =>
        getInitialState('filtriSondaggi_dateRange', [null, null])
    );

    useEffect(() => {
        sessionStorage.setItem('filtriSondaggi_dateRange', JSON.stringify(dateRange));
    }, [dateRange]);

    useEffect(() => {
        sessionStorage.setItem('filtriSondaggi_selectedOptions', JSON.stringify(selectedOptions));
    }, [selectedOptions]);

    useEffect(() => {
        sessionStorage.setItem('filtriSondaggi_categoriaFilter', JSON.stringify(categoriaFilter));
    }, [categoriaFilter]);

    useEffect(() => {
        sessionStorage.setItem('filtriSondaggi_statoFilter', JSON.stringify(statoFilter));
    }, [statoFilter]);

    const [rispostePerSondaggio, setRispostePerSondaggio] = useState({});


    //stato per aprire o meno i filtri a schermo piccolo
    const [open, setOpen] = useState(false);

    //stati per la paginazione
    const [paginaNumero, setPaginaNumero] = useState(0)
    const elementiPerPagina = 5



    //stato per contenere la lista di sondaggi ripresa dal db
    let [listaSondaggi, setListaSondaggi] = useState([])
    let [loadingSon, setLoadingSon] = useState(true)

    const [selectValue, setSelectValue] = useState(-1)


    //Funzione per azzerare i filtri
    const pulisciFiltri = () => {
        setDateRange([null, null])
        setselectedOptions([])
        setCategoriaFilter([])
        setStatoFilter([])
        setPaginaNumero(0); //resetto alla prima pagina

        // Aggiungi la pulizia del sessionStorage
        sessionStorage.removeItem('filtriSondaggi_dateRange');
        sessionStorage.removeItem('filtriSondaggi_selectedOptions');
        sessionStorage.removeItem('filtriSondaggi_categoriaFilter');
        sessionStorage.removeItem('filtriSondaggi_statoFilter');
    }

    //Funzione per filtrare sullo stato del sondaggio
    let filterByStato = (stato, checked) => {
        if (checked === true) {
            if (statoFilter.filter(statoItem => statoItem === stato).length === 0) {
                setStatoFilter(old => [...old, stato])
            }
        } else {
            setStatoFilter(statoFilter.filter(statoItem => statoItem !== stato))
        }
        setPaginaNumero(0); //resetto alla prima pagina
    }

    //funzione chiamata quando viene filtrato per categoria del sondaggio
    let filterByCategoria = (categoria, selected) => {
        if (selected === true) {
            if (categoriaFilter.filter(categoriaItem => categoriaItem === categoria).length === 0)
                setCategoriaFilter(old => [...old, categoria])
        } else {
            setCategoriaFilter(categoriaFilter.filter(categoriaItem => categoriaItem !== categoria))
        }
        setPaginaNumero(0)
    }

    //recupero dei sondaggi dal db al campiare di props.comune.comId
    useEffect(() => {
        if (!props.comune.comId) return;

        const fetchSondaggi = async () => {
            try {
                setLoadingSon(true);

                const res = await SondaggiService.getAllByComune(props.comune.comId);
                const sondaggi = res.data;
                setListaSondaggi(sondaggi);

                // Unisci categorie per i filtri
                const opt = props.comune.impostazioniComune?.imcCategorieSondaggi?.categorie_sondaggi || [];
                const allCategorie = [...opt, ...sondaggi.flatMap(p => p.sonCategorie.categorie)];
                const categoriePresenti = [...new Set(allCategorie)].sort().map((el, index) => ({ name: el, id: index }));
                setOptions(categoriePresenti);

                // Recupera le risposte per ogni sondaggio
                const risposte = {};
                await Promise.all(
                    sondaggi.map(async sondaggio => {
                        try {
                            const res = await SondaggioPartecipanteService.getTotalePartecipantiSondaggio(sondaggio.sonId);
                            risposte[sondaggio.sonId] = res.data;
                        } catch (err) {
                            console.error(`Errore nel recupero delle risposte per il sondaggio ${sondaggio.sonId}`, err);
                            risposte[sondaggio.sonId] = 0;
                        }
                    })
                );
                setRispostePerSondaggio(risposte);
            } catch (err) {
                console.error("Errore nel caricamento dei sondaggi:", err);
                setListaSondaggi([]);
            } finally {
                setLoadingSon(false);
            }
        };

        fetchSondaggi();
    }, [props.comune.comId]);


    const handleSelect = (_, selectedItem) => {
        setCategoriaFilter(old => [...old, selectedItem.name])
        setselectedOptions(old => [...old, selectedItem])
        setPaginaNumero(0)
    }

    const handleRemove = (_, removedItem) => {
        setselectedOptions(old => old.filter(el => el.id !== removedItem.id))
        setCategoriaFilter(categoriaFilter.filter(el => el !== removedItem.name))
        setPaginaNumero(0);
    }



    //funzione chiamata quando viene filtrato per data di inizio del sondaggio
    const handleDateRangeChange = (update) => {
        if (update === null) {
            setDateRange([null, null])
        } else {
            setDateRange(update);
        }
        setPaginaNumero(0); // resetto alla prima pagina
    }

    const getSondaggi = () => {
        let ret = listaSondaggi

        ret = ret.filter(sondaggio => sondaggio.sonStato !== statiSondaggio.NonPubblicato)

        if (statoFilter.length > 0) {
            ret = ret.filter(son => statoFilter.includes(son.sonStato))
        }
        if (categoriaFilter.length > 0) {
            ret = ret.filter((son) => son.sonCategorie.categorie.some(cat => categoriaFilter.includes(cat)))
        }

        if (dateRange[0]) {
            let startDay = dayjs(dateRange[0]).format('YYYY-MM-DD'); // Converte in formato "YYYY-MM-DD"
            ret = ret.filter(sondaggio =>
                dayjs(sondaggio.sonDataInizio).format('YYYY-MM-DD') >= startDay
            );
        }

        if (dateRange[1]) {
            let endDay = dayjs(dateRange[1]).format('YYYY-MM-DD'); // Converte in formato "YYYY-MM-DD"
            ret = ret.filter(sondaggio =>
                dayjs(sondaggio.sonDataInizio).format('YYYY-MM-DD') <= endDay
            );
        }

        return ret;
    }


    if (props.comune && props.comune.impostazioniComune) {
        if (props.comune.impostazioniComune.imcModuloSondaggiAttivo) {
            return (
                <>
                    {/* SFONDO AZZURRO A CAPO PAGINA*/}
                    <div className="bg-secondary w-100 position-absolute" style={{ minHeight: "30vh", zIndex: "-1" }} />
                    <h1 className="title mt-4 text-center dark">Sondaggi</h1>
                    <Card className="mx-md-5 mt-2 mb-5" style={{ minHeight: "100vh" }}>
                        <Card.Body className="p-0 m-0">
                            {/* FILTRI A SCHERMO PICCOLO */}
                            <Row className="d-md-none w-100 p-0 m-0">
                                <Col xs={12} className="p-1">
                                    <Button className="w-100" onClick={() => setOpen(!open)} >
                                        <RiFilter3Line className="me-2" />
                                        Mostra filtri
                                    </Button>
                                </Col>
                                <Collapse in={open} className="border-bottom pb-3">
                                    <div id="example-collapse-text">
                                        <h4 className="mt-4">Filtra per:</h4>
                                        <div className="divider my-4" />
                                        <Row>
                                            <Col>
                                                {/*Filtro su categoria*/}
                                                <p>Categoria</p>
                                                <Multiselect
                                                    options={options}
                                                    selectedValues={selectedOptions}
                                                    onSelect={handleSelect}
                                                    onRemove={handleRemove}
                                                    displayValue="name"
                                                    onChange={(ev) => {
                                                        filterByCategoria(ev.target.value)

                                                    }}
                                                    placeholder="Seleziona"
                                                    emptyRecordMsg="Nessuna opzione disponibile"
                                                />
                                            </Col>
                                            <Col>
                                                <p>Stato</p>
                                                <Form.Group>
                                                    {Object.values(statiSondaggio)
                                                        .filter(e => e !== statiSondaggio.NonPubblicato)
                                                        .map((stato, index) => (

                                                            <Form.Check
                                                                key={index}
                                                                type="checkbox"
                                                                label={stato}
                                                                name={stato}
                                                                checked={statoFilter.includes(stato)}
                                                                onChange={(e) => {
                                                                    filterByStato(e.target.name, e.target.checked)
                                                                }}
                                                            />
                                                        ))
                                                    }
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="datepicker-wrapper">
                                                <p>Data inizio &nbsp;
                                                    <span className="small text-muted">(Da ... a)</span>
                                                </p>
                                                <DateRangePicker
                                                    className="w-100 datepicker-container"
                                                    id="datePickerSondaggi"
                                                    onChange={(update) => { handleDateRangeChange(update) }}
                                                    value={dateRange}
                                                    returnValue="range"
                                                    calendarIcon={<FaRegCalendarAlt style={{ height: '1em', width: '1em' }} />}
                                                    dayPlaceholder="gg"
                                                    monthPlaceholder="mm"
                                                    yearPlaceholder="aaaa"
                                                    yearAriaLabel="year"
                                                    format="dd/MM/y"
                                                />
                                            </Col>

                                        </Row>

                                        <div className="d-flex justify-content-center mt-4">
                                            <Button size="sm" variant="outline-primary"
                                                onClick={() => { pulisciFiltri() }}>
                                                Pulisci filtri di ricerca
                                            </Button>
                                        </div>
                                    </div>
                                </Collapse>
                            </Row>
                            <Row className="w-100 m-0 p-0" style={{ minHeight: "100vh" }}>
                                {/* FILTRI A SCHERMO GRANDE*/}
                                <Col md={3} className="bg-light d-none d-md-block">
                                    <h4 className="mt-4">Filtra per:</h4>
                                    <div className="divider my-4" />
                                    <p >Categorie</p>
                                    <Multiselect
                                        options={options}
                                        selectedValues={selectedOptions}
                                        onSelect={handleSelect}
                                        onRemove={handleRemove}
                                        displayValue="name"
                                        onChange={(ev) => {
                                            filterByCategoria(ev.target.value)
                                            setselectedOptions(ev.target.value)
                                        }}
                                        placeholder="Seleziona"
                                        emptyRecordMsg="Nessuna opzione disponibile"
                                    />
                                    <div className="divider my-4" />
                                    <p >Stato</p>
                                    <Form.Group>
                                        {Object.values(statiSondaggio)
                                            .filter(e => e !== statiSondaggio.NonPubblicato)
                                            .map((stato, index) => (
                                                <Form.Check
                                                    key={index}
                                                    type="checkbox"
                                                    label={stato}
                                                    name={stato}
                                                    checked={statoFilter.includes(stato)}
                                                    onChange={(e) => {
                                                        filterByStato(e.target.name, e.target.checked)
                                                    }}
                                                />
                                            )
                                            )}
                                    </Form.Group>

                                    <div className="divider my-4" />
                                    <p >Data inizio &nbsp;
                                        <span className="small text-muted ">(Da ... a)</span>
                                    </p>
                                    <div>
                                        <DateRangePicker className="w-100"
                                            id="datePickerPetizioni"
                                            onChange={(update) => { handleDateRangeChange(update) }}
                                            value={dateRange}
                                            returnValue="range"
                                            calendarIcon={<FaRegCalendarAlt style={{ height: '1em', width: '1em' }} />}
                                            dayPlaceholder="gg"
                                            monthPlaceholder='mm'
                                            yearPlaceholder='aaaa'
                                            yearAriaLabel="year"
                                            format='dd/MM/y'
                                        />
                                    </div>
                                    <div className="divider my-4" />
                                    <div className="d-flex justify-content-center">
                                        <Button size="sm" variant="outline-primary"
                                            onClick={() => { pulisciFiltri() }}>
                                            Pulisci filtri di ricerca
                                        </Button>
                                    </div>

                                </Col>
                                {/*TUTTI I SONDAGGI */}
                                <Col md={9} xs>
                                    {
                                        loadingSon ?
                                            <Container className="text-center mt-5">
                                                <Spinner animation="border" role="status" />
                                            </Container>
                                            :
                                            <>
                                                {listaSondaggi.length > 0 ? (
                                                    getSondaggi()
                                                        .map(son => { return { ...son, sonStato: getStatusSondaggio(son, props.comune) } })
                                                        .filter(sondaggio => sondaggio.sonStato !== statiSondaggio.NonPubblicato)
                                                        .sort((a, b) => { return getStatusOrderSondaggio(b.sonDataInizio) - getStatusOrderSondaggio(a.sonDataInizio) })
                                                        .slice(paginaNumero * elementiPerPagina, (paginaNumero + 1) * elementiPerPagina)
                                                        .map((sondaggio, index) => (
                                                            <CartaSondaggio key={index}
                                                                numeroRisposte={rispostePerSondaggio[sondaggio.sonId] || 0}
                                                                sondaggio={sondaggio} setActiveTab={props.setActiveTab} />
                                                        ))
                                                ) : (<Container className="text-center mt-5 mb-5">

                                                    <RiEmotionSadLine size="2em" className="me-2" />
                                                    <span>Nessun sondaggio disponibile al momento!</span>
                                                </Container>)
                                                }
                                                {getSondaggi().length > 0 ? (
                                                    <PaginationBasic
                                                        activepage={paginaNumero}
                                                        setActivePage={setPaginaNumero}
                                                        numItems={getSondaggi().length}
                                                        itemsPerPage={elementiPerPagina}
                                                    />
                                                ) : null}
                                            </>
                                    }
                                </Col>
                            </Row>
                        </Card.Body>

                    </Card>
                </>
            )
        } else {
            return (
                <>
                    <Navigate replace to="/pagina-non-trovata" />
                </>
            )
        }
    }
}